import { useSelector } from "react-redux";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const SubscriptionDistribution = () => {
  const { revenue } = useSelector((state) => state.revenue);

  const options = {
    categoryPercentage: 0.5,
    barPercentage: 0.4,
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
        text: "Subscription Distribution",
      },
    },
  };

  const labels = ["Free", "Paid"];

  const data = {
    labels,
    datasets: [
      {
        label: "Users",
        data: [revenue?.freeUsers, revenue?.paidUsers],
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };

  return (
    <div className="h-100 card shadow rounded-4">
      <div className="card-body">
        <h5 className="mb-0">Subscription Distribution</h5>
        <Bar options={options} data={data} />
      </div>
    </div>
  );
};

export default SubscriptionDistribution;
